import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class ScrollImageChanger {
  constructor(elms) {
    this.dom = {elms: elms};
    this.dom.fixedImages = document.querySelector('[data-js="fixed-images"]');
    this.dom.list = this.dom.fixedImages.querySelectorAll('[data-js="list"]');

    gsap.registerPlugin(ScrollTrigger);

    this.init();
  }

  init() {
    const _this = this;
    [...this.dom.elms].forEach((el, index) => {
      const target = this.dom.list[index];

      ScrollTrigger.create({
        trigger: el,
        id: index + 1,
        start: 'top center',
        end: 'bottom center',
        // toggleClass: {
        //   targets: target,
        //   className: 'is-current'
        // },
        once: false,
        markers: false,
        onEnter: () => {
          // console.log('enter');
          [...this.dom.list].forEach(el=>{
            if (el.dataset.is === 'current') {
              el.removeAttribute('data-is');
            }
          })
          target.dataset.is = 'current';
        },
        // onLeave: () => console.log('leave'),
        onEnterBack: () => {
          // console.log('enter back');
          [...this.dom.list].forEach(el=>{
            if (el.dataset.is === 'current') {
              el.removeAttribute('data-is');
            }
          })
          target.dataset.is = 'current';
          target.dataset.is = 'current';
        },
        // onLeaveBack: () => console.log('leave back'),
      });
    });
  }
}

export default ScrollImageChanger